









































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Both extends Vue {
  @Prop({ default: '24' }) readonly size?: string;
  @Prop({ default: '#3E24D6' }) readonly color?: string;
}
